export default __webpack_public_path__ + "static/media/invoice-3739354_640.9985e4f8.jpg";